/**
 * Copy for the Resume Active Session modal (components/ResumeSessionModal).
 * While a resume runs the modal stays up and says so (owner, 2026-10-07): the
 * join restores the call's transcript and alerts before it returns, which can
 * take a few seconds.
 */
export const RESUME_SESSION_COPY = {
  resume: 'Resume',
  resuming: 'Resuming session…',
  resumingDetail: 'Restoring the conversation and alerts so far.',
  startNew: 'Start New Session',
  close: 'Close modal',
} as const;
